/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

/**
 * Check form validity
 */
export function checkFormValidity(form: HTMLFormElement, notify: boolean = true): boolean {
    const valid = notify
        ? form.reportValidity()
        : form.checkValidity();

    form.classList.toggle('invalid', !valid);
    form.classList.add('validated');

    return valid;
}

/**
 * Initialize form submit validation hook.
 *
 * @returns remove validation hook
 */
export function initFormValidation(form: HTMLFormElement) {
    const noValidate = form.noValidate;
    form.noValidate = true;

    const listener = (event: SubmitEvent) => {
        const valid = checkFormValidity(form);

        if (!valid) {
            event.preventDefault();
            event.stopPropagation();
        }
    };

    form.addEventListener('submit', listener);

    return () => {
        form.noValidate = noValidate;
        form.removeEventListener('submit', listener);
    };
}
